import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import { GetActiveEducationMaterialsApi } from "../../../api/request/knowledgeHub.js";
import getEducationColumns from "../../../columns/EducationMaterials.js";

const Education = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchEducationMaterials = async () => {
        try {
            setIsLoading(true);
            const { data: response } = await GetActiveEducationMaterialsApi();
            if (response?.success) {
                setData(response?.data || []);
            }
        } catch (error) {
            console.error("Failed to fetch education materials:", error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEducationMaterials();
    }, []);

    const handleView = (item) => {
        navigate(`/education/${item.id}`, { state: { material: item } });
    };

    const columns = getEducationColumns(handleView);

    return (
        <div>
            <div className="border border-gray-200 rounded-xl hover-disabled-table">
                <TableWithSkeleton
                    columns={columns}
                    data={data}
                    loading={isLoading}
                    rowKey="id"
                />
            </div>
        </div>
    );
};

export default Education;
